import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import router from './routes';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Store from './store';
import { ConfirmContextProvider, ConfirmationContainer } from './features/commons/components/index';

const { store, persistor } = Store();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ConfirmContextProvider>
      <PersistGate loading={null} persistor={persistor}>
        <RouterProvider router={router} />
        <ConfirmationContainer />
        <ToastContainer />
      </PersistGate>
    </ConfirmContextProvider>
  </Provider>
);
